<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { parseToFormat } from '@/utils/date';

export default {
    props: {
        value: {
            type: Boolean,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            status: {
                ENVIADO_PARA_ANALISE: this.$tc(
                    'analyze-deforestation.words.status_pending_analyze'
                ),
                EM_ANALISE: this.$tc(
                    'analyze-deforestation.words.status_in_analyze'
                ),
                ANALISE_FINALIZADA: this.$tc(
                    'analyze-deforestation.words.status_completed'
                )
            }
        };
    },
    computed: {
        ...mapState('analyzeDeforestationStore', ['report']),
        data() {
            return this.report;
        },
        visible: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        ...mapActions('analyzeDeforestationStore', [
            'detail',
            'downloadReport'
        ]),
        ...mapMutations('analyzeDeforestationStore', {
            setReport: 'SET_REPORT'
        }),
        async download() {
            try {
                const file = await this.downloadReport(this.data.id);
                const url = URL.createObjectURL(file.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `laudo-${this.data.id}.pdf`;
                document.body.appendChild(link); // Append to body to ensure visibility in certain browsers
                link.click();
                document.body.removeChild(link); // Clean up
                this.$notify.success({
                    message: 'Laudo baixado com sucesso'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao baixar o laudo do CAR'
                });
            }
        },
        parseToFormat
    },
    mounted() {
        this.detail(this.item.id);
    },
    beforeDestroy() {
        this.setReport(null);
    }
};
</script>

<template>
    <el-dialog
        v-if="visible"
        :visible.sync="visible"
        :title="$tc('analyze-deforestation.messages.car_view_dialog_title')"
        width="86%"
    >
        <h3>
            {{ $tc('analyze-deforestation.words.territory') }}:
            <span>{{ item?.dadosAdicionais?.territorio || 'N/A' }}</span>
        </h3>
        <h3>
            {{ $tc('analyze-deforestation.words.farmers') }}:
            <span>
                {{ item?.dadosAdicionais?.produtores?.join(', ') || 'N/A' }}
            </span>
        </h3>
        <h3>{{ $tc('analyze-deforestation.words.car_number') }}:</h3>
        <div class="cars-list">
            <template v-if="item?.dadosAdicionais?.cars.length">
                <span v-for="car in item?.dadosAdicionais?.cars" :key="car">
                    {{ car }}
                </span>
            </template>
            <template v-else>
                <span>N/A</span>
            </template>
        </div>
        <el-divider />
        <h3>{{ $tc('analyze-deforestation.words.history') }}:</h3>
        <div id="history-list">
            <div
                v-for="etapa in data?.etapas"
                :key="etapa.id"
                class="history-list-item"
            >
                <div>
                    <span
                        >{{
                            $tc('analyze-deforestation.words.datetime')
                        }}:</span
                    >
                    <span>{{
                        parseToFormat(etapa.createdAt, 'DD/MM/YYYY às HH:mm')
                    }}</span>
                </div>
                <div>
                    <span
                        >{{ $tc('analyze-deforestation.words.status') }}:</span
                    >
                    <span>{{ status[etapa.etapa] }}</span>
                </div>
                <div class="actions">
                    <el-button
                        v-if="etapa.etapa === 'ANALISE_FINALIZADA'"
                        type="primary"
                        size="mini"
                        @click="download()"
                    >
                        {{
                            $tc(
                                'analyze-deforestation.messages.car_view_dialog_btn_download'
                            )
                        }}
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<style scoped lang="scss">
h3 {
    color: var(--primary);
    font-size: 16px;
    font-weight: 600;
    margin: 8px 0;
    span {
        font-weight: 300;
    }
}
.cars-list {
    display: flex;
    flex-direction: column;
}
#history-list {
    .history-list-item {
        display: flex;
        justify-content: space-between;
        margin: 8px 0;
        background-color: #f2f2f2;
        padding: 20px;
        border-radius: 8px;
        flex-direction: row;
        @media (max-width: 768px) {
            flex-direction: column;
        }

        div {
            display: flex;
            flex-direction: column;
            justify-content: center;

            span:first-child {
                font-weight: 600;
                color: var(--primary);
            }
            span {
                line-height: 1.5;
                font-weight: 400;
            }
        }
        .actions {
            display: flex;
            align-items: center;
            width: 20%;
            @media (max-width: 768px) {
                margin-top: 8px;
                align-items: start;
            }
        }
    }
}
</style>
